import { render, staticRenderFns } from "./CardPropertyBoolean.vue?vue&type=template&id=1465f664&scoped=true&"
import script from "./CardPropertyBoolean.vue?vue&type=script&lang=js&"
export * from "./CardPropertyBoolean.vue?vue&type=script&lang=js&"
import style0 from "./CardPropertyBoolean.vue?vue&type=style&index=0&id=1465f664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465f664",
  null
  
)

export default component.exports
import {QField,QToggle,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QField,QToggle,QBtn,QTooltip}, component.options.components || {})
